import { render, staticRenderFns } from "./sheet.vue?vue&type=template&id=5597566e&scoped=true&"
import script from "./pc-sheet.ts?vue&type=script&lang=ts&"
export * from "./pc-sheet.ts?vue&type=script&lang=ts&"
import style0 from "./sheet.vue?vue&type=style&index=0&id=5597566e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5597566e",
  null
  
)

export default component.exports